import {SliceData} from "./SlicePairs";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {KitchenDramaSushiMania} from "../../KitchenDramaSushiMania";

/**
 * Class description
 *
 * Created: 2017-02-02
 * @author jonas
 */
export class KitchenDramaSliceAnimation extends PIXI.Container {
    get data():SliceData {
        return this._data;
    }

    get klink():TimelineSprite {
        return this._klink;
    }

    get sliceAbove():PIXI.Sprite {
        return this._sliceAbove;
    }

    get swoosh():TimelineSprite {
        return this._swoosh;
    }

    get sliceBehind():PIXI.Sprite {
        return this._sliceBehind;
    }


    private _data:SliceData;
    private _sliceAbove:PIXI.Sprite;
    private _sliceBehind:PIXI.Sprite;
    private _swoosh:TimelineSprite;
    private _klink:TimelineSprite;

    constructor(sliceData:SliceData, isSlam:boolean = false) {
        super();
        this._data = sliceData;

        //Behind
        this._sliceBehind = new PIXI.Sprite(KitchenDramaSushiMania.assetLoader.getTextures("slice/" + sliceData.sliceBehind)[0]);
        this._sliceBehind.anchor.set(0.5, 0.5);
        this.addChild(this._sliceBehind);


        //Swoosh
        this._swoosh = new TimelineSprite(KitchenDramaSushiMania.assetLoader.getTextures(sliceData.swooshName));
        this._swoosh.anchor.set(0.5, 0.5);
        this._swoosh.position.set(sliceData.x, sliceData.y);
        this._swoosh.rotation = sliceData.rotation;
        this.addChild(this._swoosh);


        //Above / Klink
        if(isSlam) {
            this._klink = new TimelineSprite(KitchenDramaSushiMania.assetLoader.getTextures(sliceData.sliceAbove));
            this._klink.anchor.set(0.5, 0.5);
            this._klink.position.set(sliceData.klinkX, sliceData.klinkY);
            this._sliceBehind.addChild(this._klink);
            this._sliceAbove = new PIXI.Sprite(PIXI.Texture.EMPTY);
            this._sliceAbove.anchor.set(0.5, 0.5);
        }
        else {
            this._sliceAbove = new PIXI.Sprite(KitchenDramaSushiMania.assetLoader.getTextures("slice/" + sliceData.sliceAbove)[0]);
            this._sliceAbove.anchor.set(0.5, 0.5);
        }
        this.addChild(this._sliceAbove);


        this.hide();
    }

    public show() {
        this.visible = true;
    }

    public hide() {
        this.visible = false;
    }
}